const requestTypes = {
  SUGGESTIONS_REQUEST: 'SUGG',
  AMBULANCE_REQUEST: 'AMBU',
  TELEPHONE_CONTACT_REQUEST: 'TLEC',
  PROFILE_UPDATE_REQUEST: 'PRDT',
  APPOINTMENT_CHANGE_REQUEST: 'CHAP',
  APPOINTMENT_REQUEST: 'APPT'
};

const requestTypeUrls = {
  [requestTypes.AMBULANCE_REQUEST]: '/request/ambulance',
  [requestTypes.TELEPHONE_CONTACT_REQUEST]: '/request/phoned',
  [requestTypes.SUGGESTIONS_REQUEST]: '/request/send-suggestion',
  [requestTypes.APPOINTMENT_REQUEST]: '/request/appointment',
  [requestTypes.APPOINTMENT_CHANGE_REQUEST]: '/request/change-appointment'
}

const requestStates = {
  REQUESTED: 1,
  REVISED: 2,
  ACCEPTED: 3,
  REJECTED: 4,
}

const requestStateViews = {
  IN_PROGRESS: 'IN_PROGRESS',
  CLOSED: 'CLOSED'
}

const requestTasksStateViewInProgress = {
  [requestStateViews.IN_PROGRESS]: true,
  [requestStateViews.CLOSED]: false
}

const requestTasksTabs = [
  {
    name: 'SI_IN_PROGRESS',
    route: 'in-progress',
  },
  {
    name: 'SI_CLOSED_F_PL',
    route: 'closed'
  }
];

const requestProfileTypes = {
  PERSONAL_DATA_UPDATE: 'PERSONAL_DATA_UPDATE',
  ADDRESS_UPDATE: 'ADDRESS_UPDATE',
  CONTACT_UPDATE: 'CONTACT_UPDATE',
  OTHER: 'OTHER'
}

const requestProfileTypeUrls = {
  [requestProfileTypes.PERSONAL_DATA_UPDATE]: '/profile/edit/personal-data',
  [requestProfileTypes.ADDRESS_UPDATE]: '/profile/edit/address',
  [requestProfileTypes.CONTACT_UPDATE]: '/profile/edit/contact-data',
  [requestProfileTypes.OTHER]: '/profile/edit'
}

export {
  requestStates,
  requestTasksStateViewInProgress,
  requestStateViews,
  requestTasksTabs,
  requestTypes,
  requestTypeUrls,
  requestProfileTypes,
  requestProfileTypeUrls
};

